import React from 'react';

const isEvent = (e) => Boolean(e && typeof e === "object" && "preventDefault" in e);
const useBoolState = (defaultValue = false, options) => {
  const onFalseRef = React.useRef(options?.onFalse);
  const onTrueRef = React.useRef(options?.onTrue);
  onFalseRef.current = options?.onFalse;
  onTrueRef.current = options?.onTrue;
  const shouldPreventDefault = options?.preventDefault ?? true;
  const [value, setValue] = React.useState(defaultValue);
  const handleToggle = React.useCallback((e) => {
    if (shouldPreventDefault && isEvent(e)) {
      e.preventDefault();
    }
    setValue((prevValue) => {
      const nextValue = !prevValue;
      if (!nextValue) {
        onFalseRef.current?.();
      } else {
        onTrueRef.current?.();
      }
      return nextValue;
    });
  }, [
    shouldPreventDefault
  ]);
  const handleSet = React.useCallback((arg) => {
    setValue((prevValue) => {
      const nextValue = typeof arg === "function" ? arg(prevValue) : arg;
      if (!nextValue) {
        onFalseRef.current?.();
      } else {
        onTrueRef.current?.();
      }
      return nextValue;
    });
  }, []);
  const handleTrue = React.useCallback((e) => {
    if (shouldPreventDefault && isEvent(e)) {
      e.preventDefault();
    }
    onTrueRef.current?.();
    setValue(true);
  }, [
    shouldPreventDefault
  ]);
  const handleFalse = React.useCallback((e) => {
    if (shouldPreventDefault && isEvent(e)) {
      e.preventDefault();
    }
    onFalseRef.current?.();
    setValue(false);
  }, [
    shouldPreventDefault
  ]);
  const boolState = React.useMemo(() => ({
    value,
    handleToggle,
    handleTrue,
    handleFalse,
    set: handleSet,
    modalProps: {
      open: value,
      onOpenChange: handleSet
    }
  }), [
    handleFalse,
    handleToggle,
    handleTrue,
    value,
    handleSet
  ]);
  if (options?.ref) {
    options.ref.current = boolState;
  }
  return boolState;
};

export { useBoolState };
//# sourceMappingURL=useBooleanState.js.map
